import { Material } from "./material.model";

export class LessonPlan {
  constructor(
    public id: string = "",
    public name: string = "",
    public learningObjective: string = "",
    public materials: Material[] = []
  ) {}
}
